const PENDING = 'PENDING';
const RUNNING = 'RUNNING';
const SUCCESS = 'SUCCESS';
const FAILED = 'FAILED';
const REJECTED = 'REJECTED';
const NOT_STARTED = 'NOT_STARTED';

export default {
    PENDING,
    RUNNING,
    SUCCESS,
    FAILED,
    REJECTED,
    NOT_STARTED,
};
